import { useEffect, useState } from "react";

const isDarkNow = () =>
  typeof document !== "undefined" &&
  document.documentElement.classList.contains("dark");

/**
 * 現在ダークテーマかどうかを購読する。
 *
 * CSS だけで完結する箇所には不要。canvas/SVG を自前で描くグラフのように、
 * JavaScript 側へ色を渡さないとテーマに追従できないものだけがこれを使う。
 * SSR 中は document が無いためライト扱いで描画し、ハイドレート後に実際の値へ合わせる。
 */
export default function useDarkModeState() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    setIsDark(isDarkNow());

    const observer = new MutationObserver(() => setIsDark(isDarkNow()));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return isDark;
}
